









































































import { ApprovalStatus } from '@/utils/types'
import Vue from 'vue'
import Component from 'vue-class-component'
import { Action } from 'vuex-class'

@Component
export default class ResetPassword extends Vue {
  approvalStatus = ApprovalStatus;
  password = '';
  confirmPassword = '';
  resetPasswordStatus: ApprovalStatus = ApprovalStatus.PENDING;
  rules = {
    required: (value: string) => !!value || 'שדה חובה',
    min: (value: string) => value.length >= 8 || 'לפחות 8 תווים'
  };

  @Action sendResetPassword!: (payload: {
    jwt: string
    password: string
  }) => Promise<boolean>;

  /**
   * Validates current form values
   */
  private get isFormValid () {
    return this.password.length >= 8 && this.password === this.confirmPassword
  }

  async resetPassword () {
    if (!this.isFormValid) {
      return
    }
    const isSuccessful = await this.sendResetPassword({
      jwt: this.$route.params.token,
      password: this.password
    })
    this.resetPasswordStatus = isSuccessful
      ? ApprovalStatus.APPROVED
      : ApprovalStatus.REJECTED
  }
}
